/** Typed accessor for build-time env vars — import this instead of `import.meta.env` directly. */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
} as const;
